import { styled } from "styled-components";

export const AuthPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
  .banner {
    width: 90%;
  }
  .banner img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  div {
    box-sizing: border-box;
  }
  .inputsContainer {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .inputs_block {
    background-color: white;
    border-radius: 6px;
    flex-grow: 1;
    /* min-height: 100%; */
    /* display: flex;
    flex-direction: column; */
    overflow: auto;
  }
  .forgot_password_btn {
    background-color: transparent;
    outline: none;
    border: none;
    color: white;
    margin: 5px 0px;
  }
  .login_tag_btn {
    background: none;
    outline: none;
    border: none;
  }
  .sbmit_btn {
    background-color: #001847;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 8px;
    outline: none;
    border: none;
    color: white;
    height: 48px;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .img_logo {
    width: 50px;
    margin-bottom: 5px;
  }
  .content_block_col {
    background-color: #f5f5f5;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .content_block {
      background-color: white;
      width: 95%;
      min-height: 75vh;
      padding: 30px 80px;
      border-radius: 10px;
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  input {
    border: none;
    outline: none;
    padding: 0px 10px;
  }
  .input_box {
    display: flex;
    align-items: center;
    border-radius: 8px;
    height: 45px;
    border: 1px solid rgb(200, 200, 200);
  }
  .icon_box {
    height: 25px;
    width: 25px;
    border: 0px solid;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .image_icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 0px solid;
  }
  .country_code_box {
    /* width: 100px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    height: 45px;
    border: 1px solid rgb(200, 200, 200);
  }
`;
